import { createContext } from "react";

import type { GlobalState } from "./types";

export const defaultGlobalState: GlobalState = {
  currentAppGroupId: document.querySelector("meta[name=app-group-id]")?.getAttribute("content") || "",
  inEditorDomain: document.querySelector("meta[name='in-editor-domain']")?.getAttribute("content") === "1",
};

export const GlobalStateContext = createContext(defaultGlobalState);
